const states = (['AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY',
    'Alabama', 'Alaska', 'American Samoa', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'District of Columbia', 'Federated States of Micronesia', 'Florida', 'Georgia', 'Guam', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Marshall Islands', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Northern Mariana Islands', 'Ohio', 'Oklahoma', 'Oregon', 'Palau', 'Pennsylvania', 'Puerto Rico', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virgin Island', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'])

const testAppSubmissionData = {
    "ownerFName": "Kevin",
    "ownerLName": "Pilgrim",
    "ownerPhone": "8017599947",
    "ownerEmail": "pilgrimka1@yahoo.com",    
    "princStreet": "PO Box 3573",
    "princStreet2": "",
    "princCity": "Scottsdale",
    "princState": "AZ",
    "princZip": "85271",
    "princDOB": "1966-07-20",
    "princSSN": "123456789",
    "princTitle": "",
    "princMainOwner": "Yes",
    "princOwnership": "100",
    "busName": "MMISTest KP Industries",
    "tradeName": "MMISTest KP Industries",
    "busStreet": "PO Box 3573",
    "busStreet2": "",
    "busCity": "Scottsdale",
    "busState": "AZ",
    "busZip": "85271",
    "busPhone": "8017599947",
    "busURL": "",
    "mcc_Iso": "1234",
    "busDesc": "personal use",
    "whenCharged": "One time before service delivery",
    "subsOffered": "Yes",
    "deliveryTimeframe": "Instantly",
    "grossSales": "120000",
    "highestSale": "20000",
    "annualSales": "60000",
    "avgSales": "200",
    "taxId": "888888888",
    "busStart": "1966-07-20",
    "incorpStateCode": "AZ",
    "taxStatus": "Not Tax Exempt",
    "taxFilingType": "LLC",
    "finInst": "Wells Fargo",
    "finPhone": "8017599947",
    "checkingNum": "12365478",
    "bankABA": "123456789",
    "nameOnAccount": "Kevin Pilgrim",
    "authToken": "",
    "appResult": "",
    "appRef": "",
    "appInternalMID": "",
    "userId": "-1",
    "firebaseUserId": "GE3QjPuGxoPqmDxMpaSZXXM2xM82",
    "userEmail": "pilgrimka1@test.com",
    "test": ""
}

const data = {
    states, 
    testAppSubmissionData
};

export default data;